(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__alterlabCartOverrideReady) return;
  window.__alterlabCartOverrideReady = true;

  const productHandle = 'spring-2026-collection-today-tw';
  let productPromise;

  const getTodayProduct = () => {
    if (!productPromise) {
      productPromise = fetch(`/products/${productHandle}.js`, { headers: { 'Accept': 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error('Product data unavailable');
          return response.json();
        });
    }
    return productPromise;
  };





  if (!window.__alterlabMonthlyDropCountdownReady) {
    window.__alterlabMonthlyDropCountdownReady = true;
    window.__alterlabCheckoutCacheBust = true;
    const formatMonthlyDropTime = () => {
      const now = new Date();
      const end = new Date(now.getFullYear(), now.getMonth() + 1, 1, 0, 0, 0, 0);
      const totalSeconds = Math.max(0, Math.floor((end.getTime() - now.getTime()) / 1000));
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      return `${String(days).padStart(2, '0')}:${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };
    let dropStatusTimer;
    const getDropStatusUrl = () => window.__alterlabDropStatusUrl || document.querySelector('[data-al-drop-status-src]')?.dataset.alDropStatusSrc;
    const updateMonthlyDropCountdown = () => {
      document.querySelectorAll('[data-al-drop-time]').forEach((node) => { node.textContent = formatMonthlyDropTime(); });
    };
    const applyDropCheckoutState = () => {
      document.querySelectorAll('[data-cart-action="checkout"]').forEach((button) => {
        button.disabled = false;
        button.setAttribute('aria-disabled', 'false');
      });
      document.querySelectorAll('a[data-al-drop-checkout-link]').forEach((link) => {
        link.setAttribute('aria-disabled', 'false');
        link.removeAttribute('tabindex');
        if (!link.getAttribute('href')) link.setAttribute('href', link.dataset.alDropCheckoutHref || '/checkout');
      });
    };
    const normalizeDropState = (state = {}) => {
      const limit = Number(state.monthly_limit ?? state.limit ?? 0) || 0;
      const remaining = Number(state.remaining ?? 0);
      const sold = Number(state.sold ?? Math.max(0, limit - remaining));
      return { remaining, limit, sold };
    };
    const applyDropStatus = (state = {}) => {
      const { remaining, limit, sold } = normalizeDropState(state);
      document.querySelectorAll('[data-al-drop-remaining]').forEach((node) => { node.textContent = String(remaining); });
      document.querySelectorAll('[data-al-drop-limit]').forEach((node) => { node.textContent = String(limit); });
      document.querySelectorAll('[data-al-drop-sold]').forEach((node) => { node.textContent = String(sold); });
      applyDropCheckoutState(remaining);
      window.__alterlabDropState = { remaining, limit, sold };
    };
    const fetchDropStatus = async () => {
      const url = getDropStatusUrl();
      if (!url) return;
      try {
        const separator = url.includes('?') ? '&' : '?';
        const response = await fetch(`${url}${separator}al_ts=${Date.now()}`, { headers: { 'Accept': 'application/json' } });
        if (!response.ok) return;
        applyDropStatus(await response.json());
      } catch (error) {
        console.warn('ALTERLAB drop status unavailable', error);
      }
    };
    updateMonthlyDropCountdown();
    fetchDropStatus();
    window.setInterval(updateMonthlyDropCountdown, 1000);
    dropStatusTimer = window.setInterval(fetchDropStatus, 60000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) fetchDropStatus(); });
    window.addEventListener('alterlab-drop-status-refresh', fetchDropStatus);
  }



  const setDropRangeLabels = () => {
    const oldRange = '8.1-8.31';
    const newRange = 'Restock';
    document.querySelectorAll('body *').forEach((node) => {
      if (node.children.length || !node.textContent.includes(oldRange)) return;
      node.textContent = node.textContent.replaceAll(oldRange, newRange);
    });
  };
  setDropRangeLabels();
  document.addEventListener('DOMContentLoaded', setDropRangeLabels);
  window.addEventListener('load', setDropRangeLabels, { once: true });

  const selectedLandingOptions = (button) => {
    const card = button.closest('.product-card, .checkout-card') || document;
    return {
      color: card.querySelector('.color-pill.active')?.dataset.productColor || 'Beige',
      fit: card.querySelector('[data-product-fit].active')?.dataset.productFit || 'Standard',
      size: card.querySelector('[data-product-size].active')?.dataset.productSize || '5'
    };
  };

  const findLandingVariant = (variants, selected) => {
    const matches = (variant, fit) =>
      variant.option1 === selected.color &&
      variant.option2 === fit &&
      variant.option3 === selected.size &&
      variant.available;

    return variants.find((variant) => matches(variant, selected.fit)) ||
      variants.find((variant) => matches(variant, 'Standard')) ||
      variants.find((variant) => variant.available);
  };

  const addVariant = async (variantId, quantity = 1, properties = null) => {
    const payload = { id: Number(variantId), quantity: Number(quantity) || 1 };
    if (properties) payload.properties = properties;
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Add to cart failed');
    }
  };


  const giftBallVariantId = 49723300741370;
  const giftOfferStorageKey = 'alterlab-gift-offer-started-at';

  const addGiftBallIfNeeded = async () => {
    try {
      const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((response) => response.json());
      const hasGift = cart.items?.some((item) => Number(item.variant_id) === giftBallVariantId && item.properties?._alterlab_gift === '30min-3d-ball');
      if (!hasGift) {
        await addVariant(giftBallVariantId, 1, { _alterlab_gift: '30min-3d-ball', _alterlab_offer: '30min-shoe-bonus' });
      }
      sessionStorage.setItem(giftOfferStorageKey, String(Date.now()));
      window.dispatchEvent(new CustomEvent('alterlab-gift-offer-start'));
    } catch (error) {
      console.warn('ALTERLAB gift ball add skipped', error);
    }
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-action]');
    const landing = button?.closest('.alterlab-product-landing');
    if (!button || !landing) return;
    // Product landing sections own the add-to-cart and gift logic.
    return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = button.dataset.cartAction === 'checkout' ? 'Opening checkout...' : 'Adding...';

    try {
      const shouldCheckout = button.dataset.cartAction === 'checkout';
      const product = await getTodayProduct();
      const variant = findLandingVariant(product.variants || [], selectedLandingOptions(button));
      if (!variant) throw new Error('No available variant found');
      await addVariant(variant.id);
      await addGiftBallIfNeeded();

      if (shouldCheckout) {
        window.location.href = '/checkout';
        return;
      }

      if (window.Alpine?.store('cart')) {
        await window.Alpine.store('cart').fetchCart();
        window.Alpine.store('cart').open();
      }
      button.textContent = 'Added';
    } catch (error) {
      console.error('ALTERLAB compiled cart override failed:', error);
      button.textContent = 'Try again';
      alert('Could not add item to cart. Please refresh and try again.');
    } finally {
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText;
      }, 1400);
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel"] && !Shopify.designMode) return;
  try {
    
// Alpine.js 会自动处理所有交互逻辑

  } catch(e) { console.error(e); }
})();
})();
